// extracted by mini-css-extract-plugin
export default {"link":"style_link__F1H3E","centerGrid":"style_centerGrid__x1LPk"};